import { Component, OnInit, EventEmitter, Output, Inject } from '@angular/core';
import { AppService } from '../../../services/app.service';
import { BasicDetails } from '../../../models/general.model';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MasterService } from '../../../services/master.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AjaxService } from '../../../../../core/services/ajax.service';
import { Http } from '@angular/http';

@Component({
  selector: 'app-general-edit-form',
  templateUrl: './general-edit-form.component.html',
  styleUrls: ['./general-edit-form.component.scss']
})
export class GeneralEditFormComponent implements OnInit {
  @Output() closeDialogue = new EventEmitter();
  basicDetails = new BasicDetails();
  formGroup: FormGroup;
  formGroupErrors: any;
  loadingIndicator = false;
  reorderable = true;
  translations: any;
  generalId : Number = 0;
  masterTypeId : Number = 0;
  parentList: any = [];
  parentFilterCtrl: FormControl = new FormControl();
  /** Subject that emits when the component has been destroyed. */
  private _onDestroy = new Subject<void>();
  searchFlag: boolean = true;
  parentTypeId : Number = 0;  
  invalidForm = true;

  parentRequired = false;
  constructor(@Inject(MAT_DIALOG_DATA)
    public data: { Id : 0, MasterTypeId : 0 },
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private http: Http,
    private _ajaxService: AjaxService,
    public appService: AppService,public dialogRef: MatDialogRef<GeneralEditFormComponent>,public masterService:MasterService) {
        this.appService.showLoading();
        this.setPageTranslations();
        this.parentTypeId = 0;  
      this.formGroupErrors = {
        Code :{},
        Description: {},
        IsActive: {},
        ParentId: {}
    };
    
  }
 
  setPageTranslations(){
    this.translations = JSON.parse(sessionStorage.getItem('pageData')); 
  }

  ngOnInit() {
    this.masterTypeId = sessionStorage.MasterTypeId;
    this.parentTypeId = Number(sessionStorage.ParentTypeId);
    
    if(this.masterTypeId == 31){
      this.formGroup = this.formBuilder.group({
        Code:['',Validators.required],
        Description: ['', Validators.required] ,
        IsActive: ['', Validators.required],
        IsEU: ['', Validators.required],
        IncludeInFinance: ['', Validators.required]
      });
    }
    else if(parseInt(sessionStorage.ParentTypeId) > 0){
      this.formGroup = this.formBuilder.group({
        Code:['',Validators.required],
        Description: ['', Validators.required] ,
        IsActive: ['', Validators.required]
      });
    }
    else{
       this.formGroup = this.formBuilder.group({
        Code:['',Validators.required],
        Description: ['', Validators.required] ,
        IsActive: ['', Validators.required]
        });
    }
    this.formGroup.valueChanges.subscribe(() => {
        this.formGroupErrors = this.appService.onFormValuesChanged(      
          this.formGroup,
          this.formGroupErrors
        );
       if(parseInt(sessionStorage.ParentTypeId) > 0)
       {
           if(this.basicDetails.ParentId > 0 && !this.formGroup.invalid){
                this.invalidForm = false;
            } else{
                this.invalidForm = true;
            }
        }
        else if(!this.formGroup.invalid){
          this.invalidForm = false;
        }
        else{
            this.invalidForm = true;
        }
        
      });
    this.parentFilterCtrl.valueChanges
        .debounceTime(400)
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterParent();
      });
    this.generalId = this.data.Id;
    if(this.generalId > 0){
        this.selectGeneralDataById();
    }
    else{
        this.appService.hideLoading();
        this.invalidForm = true;
      }
  }
  
  onParentBlur(e){
    this.parentRequired = this.basicDetails.ParentId > 0 ? false : true;
  }
  selectGeneralDataById(): void{
    this.masterService.select(this.generalId).subscribe(
       res => this.getGeneralDetailsSuccess(res),
       error => this.apiFaillure(error)
    );
}

    getGeneralDetailsSuccess(res): void{
        if(res.Data != null){
            this.basicDetails = JSON.parse(res.Data)[0];  
            this.basicDetails.IsEU = this.basicDetails.IsEU == undefined || this.basicDetails.IsEU == null ? false : this.basicDetails.IsEU;
            this.basicDetails.IncludeInFinance = this.basicDetails.IncludeInFinance == undefined || this.basicDetails.IncludeInFinance == null ? false : this.basicDetails.IncludeInFinance; 
            if(parseInt(sessionStorage.ParentTypeId) > 0){
                this.parentFilterCtrl.setValue(this.basicDetails["Parent"]);
            }
            
            this.appService.hideLoading();
            
        }
        else{
            this.apiFaillure(res.Message);
        }
    }
       
    filterParent(){
        
        let parentId = this.basicDetails.ParentId == null ? 0 : this.basicDetails.ParentId;        
        parentId = typeof parentId != 'undefined' ? parentId : 0;
        let search = this.parentFilterCtrl.value;
        if (search && search.length > 0) {
           
            this._ajaxService
              .GET("Master.svc/master/"+
              parseInt(sessionStorage.ParentTypeId) +"/" 
              + parentId + "/0/"
              + (!search ? " " : search)+ "/0")
              .subscribe(response => {
                this.parentList = [];
                this.parentList = JSON.parse(response.Data);
                this.appService.hideLoading();
              });
          
        } else {
            this.basicDetails.ParentId = 0;
            this.parentList = [];
            this.parentRequired = true;
            if(parseInt(sessionStorage.ParentTypeId) > 0)
            {
                if(this.basicDetails.ParentId > 0
                    && !this.formGroup.invalid){
                        this.invalidForm = false;
                    } 
                    else{
                        this.invalidForm = true;
                    }
                }
               
            
            else if(!this.formGroup.invalid){
                this.invalidForm = false;
            }
            else{
                this.invalidForm = true;
            }
          }
    }


  save(): void{
    this.basicDetails.MasterTypeId = this.masterTypeId;
    this.masterService.save(JSON.stringify(this.basicDetails)).subscribe(
    res => this.saveGeneralSuccess(res),
    error => this.apiFaillure(error)
    );
 }

  saveGeneralSuccess(res): void{
    if (res.Status == 1) {
    this.appService.showDialogue(this.translations.hdSuccess, this.translations[res.Message])
    .afterClosed().subscribe(result => {
        if (result) {
        this.close();
        }          
    });    
    } else if (res.Status == -1) {
    this.apiFaillure(res.Message);
    }
 }
 
 apiFaillure(error): void {
    this.appService.showDialogue(this.translations.hdError, this.translations[error]);
 }
 
 close(){
    this.dialogRef.close();
}
onParentSelect(parentId) {
    if (this.basicDetails.ParentId != parentId) {
      this.invalidForm = true;
      this.basicDetails.ParentId = parentId;
      this.parentRequired = this.basicDetails.ParentId > 0 ? false : true;  
      if(parseInt(sessionStorage.ParentTypeId) > 0)
       {
           if(this.basicDetails.ParentId > 0
            && !this.formGroup.invalid){
                this.invalidForm = false;
            } else{
                this.invalidForm = true;
            }
        }
        else if(!this.formGroup.invalid){
          this.invalidForm = false;
        }
        else{
            this.invalidForm = true;
        }

    }
  }
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/general/general-edit-form/general-edit-form.component.ts